import type { Attendance } from '@aegislab/shared';
import { calculateTotalWorkDuration } from '@aegislab/shared';
import { formatTimeShort, formatDurationHHMM } from '@/shared/lib/format';
import { downloadCsv } from '@/shared/lib/exportCsv';

export const MY_ATTENDANCE_CSV_HEADERS = ['날짜', '출근', '퇴근', '근무시간', '상태'];

const STATUS_LABEL: Record<string, string> = {
  CLOCKED_IN: '근무 중',
  ON_BREAK: '휴식 중',
  CLOCKED_OUT: '퇴근',
};

export interface MyAttendanceRange {
  startDate?: string;
  endDate?: string;
}

/**
 * 개인 출퇴근 내역을 CSV 재료(헤더·행·파일명)로 만든다.
 * 날짜는 서버가 이미 KST 로 준 `date` 를 그대로 쓴다 — 브라우저 타임존에 안 흔들린다.
 */
export function buildMyAttendanceCsv(
  records: Attendance[],
  range: MyAttendanceRange = {}
): { headers: string[]; rows: string[][]; filename: string } {
  const rows = records.map((att) => [
    att.date,
    formatTimeShort(att.clockInAt),
    att.clockOutAt ? formatTimeShort(att.clockOutAt) : '',
    formatDurationHHMM(calculateTotalWorkDuration(att)),
    STATUS_LABEL[att.status] ?? att.status,
  ]);

  const period =
    range.startDate && range.endDate
      ? `_${range.startDate}_${range.endDate}`
      : range.startDate
        ? `_${range.startDate}_`
        : range.endDate
          ? `__${range.endDate}`
          : '';

  return {
    headers: MY_ATTENDANCE_CSV_HEADERS,
    rows,
    filename: `출퇴근내역${period}.csv`,
  };
}

export function exportMyAttendance(records: Attendance[], range: MyAttendanceRange = {}): void {
  const { headers, rows, filename } = buildMyAttendanceCsv(records, range);
  downloadCsv(filename, headers, rows);
}
